// extracted by mini-css-extract-plugin
export default {"root":"Item_root__TtRKf","img":"Item_img__GjcDb","short":"Item_short__wik+9","title":"Item_title__IImi4","num":"Item_num__lXzFB","grid":"Item_grid__nqDfL"};